import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { ModalBody, ModalFooter } from 'reactstrap';
import classNames from 'classnames';
import Modal from '../../../shared/ui/Modal';
import optionsActions from '../../store/options/action-creators';
import usersActions from '../../store/users/action-creators/index';
import ListActionSubheader from '../common/ListActionSubheader';
import PropertyActions from '../common/PropertyActions';
import AddActionButton from '../common/AddActionButton';
import adminFormatRoleName from "../../../admin-app/models/formatRoleName";
import formatRoleName from "../../models/utilities/formatRoleName";

class UserRoleList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      confirmRemoveMessage: '',
      isConfirmingRemoveRole: false,
      removeRoleGuid: null,
      trainingProgramGuid: '',
    };
  }

  // ----------------------
  // Lifecycle
  // ----------------------

  componentDidMount() {
    if (!this.props.rolesOptions) {
      this.props.fetchRolesOptions();
    }
    if (!this.props.trainingProgramsOptions) {
      this.props.fetchTrainingProgramsOptions();
    }
  }

  // ----------------------
  // Handlers
  // ----------------------

  onAddRole(role) {
    if (role.name === 'Officer in Training') {
      this.props.onAdd(role.guid, this.state.trainingProgramGuid);
    } else {
      this.props.onAdd(role.guid, null);
    }
  }

  // ----------------------
  // Computed
  // ----------------------
  getRolePropertyActions(roleGuid) {
    const setSelected = {
      label: 'Set Selected',
      handlerProp: 'onSetSelected',
      icon: 'check',
    };
    const detachRole = {
      label: 'Remove',
      handlerProp: 'onDelete',
      icon: 'trash',
    };
    return this.props.selectedRoleGuid === roleGuid
      ? []
      : [setSelected, detachRole];
  }

  getUnassignedRoles() {
    const assignedRoleGuids = this.props.roles.map(role => role.guid);
    return !this.props.rolesOptions
      ? []
      : this.props.rolesOptions.filter((option) => {
        return !assignedRoleGuids.includes(option.guid);
      });
  }

  // ----------------------
  // Methods
  // ----------------------

  confirmRemoveRole(role) {
    this.setState({
      confirmRemoveMessage: `Remove role "${role.name}"?`,
      removeRoleGuid: role.guid,
      isConfirmingRemoveRole: true,
    });
  }

  handleSelect(trainingProgramGuid) {
    this.setState({ trainingProgramGuid });
  }

  removeRole(roleGuid) {
    this.setState({
      confirmRemoveMessage: '',
      removeRoleGuid: null,
      isConfirmingRemoveRole: false,
    });
    this.props.onRemove(roleGuid);
  }

  formatUserRoleLocal(role) {
    if(this.props.userContext.scope === 'admin') {
      return adminFormatRoleName(role)
    }
    return formatRoleName(role)
  }

  // ----------------------
  // Render
  // ----------------------

  render() {
    return (
      <Fragment>
        <ListActionSubheader title="Roles">
          <AddActionButton
            label="Role"
            onAdd={() => this.props.editUserRoles()}
          />
        </ListActionSubheader>
        <div className="profile-list">
          {this.props.roles &&
            this.props.roles.map((role, index) => (
              <div
                className={classNames('profile-list-item', {
                  'is-default': role.guid === this.props.selectedRoleGuid,
                })}
                key={index.toString()}
              >
                <div className="profile-list-item-selected">
                  <i className="fa fa-check" />
                </div>
                <div className="profile-list-content">
                  <b>{this.formatUserRoleLocal(role.scope)}</b>
                </div>
                <div className="profile-list-actions">
                  {this.props.selectedRoleGuid !== role.guid && (
                    <i
                      className="fa fa-check"
                      onClick={() => this.props.onSetSelected(role.guid)}
                      role="link"
                      tabIndex={0}
                    />
                  )}
                  {this.props.selectedRoleGuid !== role.guid && (
                    <i
                      className="fa fa-trash"
                      onClick={() => this.confirmRemoveRole(role)}
                      role="link"
                      tabIndex={0}
                    />
                    )}
                </div>
              </div>
            ))}
        </div>
        <Modal
          isOpen={this.props.isEditingUserRoles}
          onClose={() => this.props.closeEditUserRoles()}
          title="Add Role"
        >
          <ModalBody className="manage-roles">
            <table className="table table-stripped">
              <thead>
                <tr>
                  <th onClick={() => this.sortByProperty('name')}>
                    <div className="header">
                      <span>Role Name </span>
                    </div>
                  </th>
                  <th>
                    <div className="header">
                      <span>Options </span>
                    </div>
                  </th>
                  <th>
                    <div className="header">
                      <span>Actions </span>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                {this.getUnassignedRoles().map((role, index) => (
                  <tr key={index.toString()}>
                    <td>{this.formatUserRoleLocal(role.scope)}</td>
                    <td>&nbsp;</td>
                    <td>
                      <button
                        className="button small default"
                        onClick={() => this.onAddRole(role)}
                      >
                        <i className="fa fa-plus" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </ModalBody>
        </Modal>
        <Modal
          isOpen={this.state.isConfirmingRemoveRole}
          onClose={() => this.setState({ isConfirmingRemoveRole: false })}
          title="Confirm Remove Role"
        >
          <ModalBody>{this.state.confirmRemoveMessage}</ModalBody>
          <ModalFooter>
            <button
              className="button primary"
              onClick={() => this.removeRole(this.state.removeRoleGuid)}
            >
              Remove
            </button>
            <button
              className="button"
              onClick={() => this.setState({ isConfirmingRemoveRole: false })}
            >
              Cancel
            </button>
          </ModalFooter>
        </Modal>
      </Fragment>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    isEditingUserRoles: state.users.isEditingUserRoles,
    rolesOptions: state.options.roles,
    trainingProgramsOptions: state.options.trainingPrograms,
    userContext: state.common.userContext
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    editUserRoles: () => {
      return dispatch(usersActions.editUserRoles());
    },
    closeEditUserRoles: () => {
      return dispatch(usersActions.closeEditUserRoles());
    },
    fetchRolesOptions: () => dispatch(optionsActions.fetchOptions('roles')),
    fetchTrainingProgramsOptions: () => {
      return dispatch(optionsActions.fetchOptions('trainingPrograms'));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UserRoleList);
